import React from 'react'
import PropTypes from 'prop-types'

import styles from './Spinner.scss'

Spinner.propTypes = {
  waitFor: PropTypes.bool,
  children: PropTypes.element
}

export default function Spinner(props) {
  const { waitFor } = props
  return waitFor ? <div className={styles.rotatingPlane} /> : props.children
}
